module.exports = __webpack_public_path__ + "img/fund-step8.3f7bf77a.png";